"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldValues = exports.validateFields = void 0;
var state_1 = require("../state");
var formEventHandlers_1 = require("./formEventHandlers");
var getIdAsIntOrFail = function (element) {
    var fieldId = element.dataset.fieldId;
    if (!fieldId) {
        return -1;
    }
    return +fieldId;
};
var parseFieldGroup = function (fields) {
    var fieldType = fields.dataset.fieldType;
    var response = [];
    if (!fieldType) {
        return response;
    }
    switch (fieldType) {
        case 'radio':
            var radioButtons = Array.from(fields.querySelectorAll('input[type=radio]'));
            var activeRadioButtons = radioButtons.filter(function (button) { return button.checked; });
            var activeButtonIds = activeRadioButtons.map(getIdAsIntOrFail);
            response = activeButtonIds;
            break;
    }
    return response;
};
var validateFields = function (pane) {
    if (pane === void 0) { pane = state_1.state.activePaneElement; }
    if (!pane) {
        return false;
    }
    var fieldset = pane.querySelector('[data-advisor-fields]');
    if (!fieldset) {
        return true;
    }
    // See what the user selected
    var results = parseFieldGroup(fieldset);
    // Additionally, if we are on step two we need to handle a conditionally required field
    var validateZip = state_1.state.activeStep === 2;
    if (validateZip && !formEventHandlers_1.ValidateZipCodeInput()) {
        return false;
    }
    return results.length > 0;
};
exports.validateFields = validateFields;
var getFieldValues = function (pane) {
    if (pane === void 0) { pane = state_1.state.activePaneElement; }
    if (!pane) {
        return [];
    }
    var fieldset = pane.querySelector('[data-advisor-fields]');
    if (!fieldset) {
        return [];
    }
    return parseFieldGroup(fieldset);
};
exports.getFieldValues = getFieldValues;
